module.exports = __webpack_public_path__ + "static/media/Ela2.fd6a3503.webp";